import { createLogger } from 'redux-logger';

const logger = createLogger({
  predicate: () => !['test', 'production'].includes(process.env.NODE_ENV),
  collapsed: true,
});

export { logger };
